var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsDateString, IsInt, IsOptional, IsString, IsUUID } from 'class-validator';
export class OfficeLocationRoomFullSizeDto {
    id;
    officeLocationId;
    officeId;
    name;
    description;
    capacity;
    createdAt;
    updatedAt;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationRoomFullSizeDto.prototype, "id", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationRoomFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationRoomFullSizeDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeLocationRoomFullSizeDto.prototype, "name", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeLocationRoomFullSizeDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeLocationRoomFullSizeDto.prototype, "capacity", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeLocationRoomFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeLocationRoomFullSizeDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=office-location-room.full-size.dto.js.map